var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.appearance.layout === 'video')?_c('div',[_c('UiVideos',{attrs:{"props-data":_vm.uiVideoPropsData}})],1):_c('div',[_c('CeTextpic',_vm._b({},'CeTextpic',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }